import CTALink from "@/components/CTA/ctaLink";
import LocalizedOfferEndsPrefix from "@/components/PromoBanner/components/LocalizedOfferEndsPrefix";
import PromoBannerTooltip from "@/components/PromoBanner/components/PromoBannerTooltip";
import type { BasePromoBannerProps } from "@/components/PromoBanner/types";
import boldTextWithAsterisk from "@/utils/functions/boldTextWithAsterisk";

export default function PromoBannerCompress({
  className,
  cta,
  ctaElement,
  description,
  discount,
  discountCode,
  endDate,
  endDatePrefix,
  learnMoreLink,
  title,
  useDefaultDiscountText = true,
  tooltip,
}: BasePromoBannerProps) {
  return (
    <div
      className={`flex flex-col sm:flex-row justify-between items-center gap-2 p-4 bg-primary rounded-[5px] ${className || ""}`}
    >
      <div className="flex-1">
        <h2 className="text-primary-foreground elm-h4 font-bold mt-0 mb-2 w-full">
          {title}
        </h2>
        <div>
          <p className="hidden sm:block text-primary-foreground elm-p2 mb-0 leading-relaxed">
            {typeof description === "string"
              ? boldTextWithAsterisk(description)
              : description}{" "}
            {useDefaultDiscountText && !!discount && !!discountCode && (
              <>
                Get <strong>up to {discount} off</strong> with code{" "}
                <strong>{discountCode}</strong>.
              </>
            )}{" "}
            <LocalizedOfferEndsPrefix prefix={endDatePrefix} date={endDate} />.{" "}
            <span className="inline-block align-middle">
              <PromoBannerTooltip
                discountCode={discountCode}
                endDate={endDate}
                learnMoreLink={learnMoreLink}
                htmlContent={tooltip?.infoText ?? ""}
                size={12}
              />
            </span>
          </p>
        </div>
      </div>
      {ctaElement}
      {cta && !ctaElement && (
        <div className="flex-shrink-0">
          <CTALink
            type="brand"
            size="xl"
            className="w-full sm:w-auto [&_span]:whitespace-nowrap"
            label={cta.label}
            url={cta.url}
            location={cta.location}
            html_id={cta.html_id}
          />
        </div>
      )}
    </div>
  );
}
